// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YHSm","top":"styles_top__G_5Fo"};